import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { learnerKeys } from './learnerKeys';
import * as submissions from '../../api/submissions';
import type { components } from '../../types/learnerApi';

type FeedbackSubmitRequest = components['schemas']['FeedbackSubmitRequest'];

export function useFeedback(assignmentId: string, moduleId: string) {
  const qc = useQueryClient();

  const queryKey = learnerKeys.feedback(assignmentId, moduleId);

  const existingFeedback = useQuery({
    queryKey,
    queryFn: () => submissions.getFeedback(assignmentId, moduleId),
    retry: (count, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      if (status === 404) return false;
      return count < 2;
    },
  });

  const submit = useMutation({
    mutationFn: (payload: FeedbackSubmitRequest) =>
      submissions.submitFeedback(assignmentId, moduleId, payload),
    onSuccess: (data) => {
      qc.setQueryData(queryKey, data);
      qc.invalidateQueries({ queryKey: learnerKeys.course(assignmentId) });
      qc.invalidateQueries({ queryKey: learnerKeys.dashboard });
      qc.invalidateQueries({ queryKey: learnerKeys.courses });
    },
  });

  return { existingFeedback, submit };
}
